module.exports = __webpack_public_path__ + "img/smart_hardware_smart_home_3.676d4eae.png";